import { action } from 'mobx';
import { FieldStoreRegistry } from 'core/registry';
import { ArrayFieldStore } from 'libs/forms/fieldStores';

export class TagsFieldStore extends ArrayFieldStore {
  @action UpdateInputValue(newValue) {
    super.UpdateInputValue(newValue);
    this.inputValue = this.inputValue
      .toLowerCase()
      .replace(' ', '-')
      .replace('--', '-');
  }
}

FieldStoreRegistry.add('tag.TagsFieldStore', TagsFieldStore);
